import { ShipperPermissionState } from './shipper-permission.types';
import {
  SHIPPER_PERMISSION_REQUEST,
  SHIPPER_PERMISSION_RESPONSE,
  ShipperPermissionActions,
} from './shipper-permission.actions.types';

const defaultState: ShipperPermissionState = {
  shipperPermissions: [],
  isFetching: false,
};

export default (
  state = defaultState,
  action: ShipperPermissionActions
): ShipperPermissionState => {
  switch (action.type) {
    case SHIPPER_PERMISSION_REQUEST: {
      return {
        ...action.payload,
      };
    }
    case SHIPPER_PERMISSION_RESPONSE: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
